import 'reflect-metadata'
import '@/entry/setupAppToolDemo.js'
import {Vue, routerManager} from './importLight'

Vue.use(routerManager.router)

routerManager.router.isReady().then(() => {
	document.dispatchEvent(new Event('prerender-start'))
}).catch(error => console.error("main-tool-demo router ready error = ", error))

Vue.mount('#app')
